export enum CreativeProductIdPrice {
    id_1 = 2100,
    id_2 = 2500,
    id_3 = 3200,
    id_4 = 3800
}
